import { Component, OnInit } from '@angular/core';
import { FeedDataService } from '../services/feed-data.service';
import { ActivatedRoute } from '@angular/router';
import { PageContentService } from '../services/page-content.service';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  
})
export class NavMenuComponent implements OnInit {
  
  isExpanded = false;
  pageFeed = "";
  feedData = "";

  ShowHeader$: boolean = true;

  constructor(private route: ActivatedRoute, protected sanitizer: DomSanitizer, private alphavantageFeedService: FeedDataService) {
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  expand(event) {
    //console.log("expand menu");
    //$(this).children('.dropdown-toggle').dropdown('show');
  }

  ngOnInit() {
    this.feedData = "EUR/USD: <b>1.0973</b>&nbsp;|&nbsp;USD/ZAR: <b>17.3740</b>&nbsp;|&nbsp;GBP/ZAR: <b>21.4316</b>&nbsp;|&nbsp;EUR/ZAR: <b>19.0620</b>&nbsp;|&nbsp;AUD/ZAR: <b>11.5547</b>";

    //this.pageFeed = this.sanitizer.bypassSecurityTrustHtml(this.feedData);
    this.pageFeed = this.feedData;

    this.route.queryParams.subscribe((params) => {
      const hideNav = params['hidenav'];

      if (hideNav === 'true') {
        this.ShowHeader$ = false;
      }

    });

    //console.log("Getting feed");
    //this.feedData = "Feed data from AlphavantageFeedService";
    /*try {
      this.alphavantageFeedService.getData().subscribe((response) => {
        //console.log("Got content - " + JSON.stringify(response));
        this.pageFeed = this.sanitizer.bypassSecurityTrustHtml(response.feed);
      });
    }
    catch (ex) {
      console.log("Get feed: " + ex);
    } */
  }
}
